import { render, staticRenderFns } from "./SendCredentialLink.vue?vue&type=template&id=287cc845"
import script from "./SendCredentialLink.vue?vue&type=script&lang=js"
export * from "./SendCredentialLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports